const statusColorFilter = (val) => {
  switch (val) {
    case -1:
      return "#999999";
    case 0:
      return "#f56c6c";
    case 1:
      return "#78f03d";
    case 10:
      return "#f56c6c";
  }
}
const statusFilter = (val) => {
  switch (val) {
    case -1:
      return "离线";
    case 0:
      return "断电";
    case 1:
      return "通电";
    case 10:
      return "继电器故障";
    default:
      return '--';
  }
}
const waterStatusFilter = (val) => {
  switch (val) {
    case -1:
      return "离线";
    case 0:
      return "关阀";
    case 1:
      return "开阀";
    case 10:
      return "阀控故障";
    default:
      return '--';
  }
}
export { statusColorFilter, statusFilter, waterStatusFilter }
